<template>
  <section class="excess-form">
    <div
      v-for="(excessItem, excessIndex) in excessForm"
      :key="excessIndex"
      class="box">
      <h3>{{ excessItem.title }}</h3>
      <div
        v-for="(item, index) in excessItem.items"
        :key="index">
        <div class="form-item">
          <span>{{ item.label }}</span>
          <div class="flex-sb">
            <template v-if="item.sp_sn === 1">
              <div
                v-if="item.field_1"
                class="form-half-3">
                <v-input
                  v-model="item.value_1"
                  :disabled="disabled"
                  :keyFloatNumber="true"
                  maxlength="8"
                  prepend="$" />
              </div>
              <div
                v-if="item.field_2"
                :disabled="disabled"
                class="form-half-3">
                <v-input
                  v-model="item.value_2"
                  :disabled="disabled"
                  :keyFloatNumber="true"
                  maxlength="8"
                  prepend="$" />
              </div>
              <div
                v-if="item.field_3"
                class="form-half-3">
                <v-input
                  v-model="item.value_3"
                  :disabled="disabled"
                  :keyFloatNumber="true"
                  maxlength="8"
                  prepend="$" />
              </div>
            </template>
            <template v-else>
              <div
                v-if="item.field_1"
                class="form-half">
                <v-input
                  v-model="item.value_1"
                  :disabled="disabled"
                  :keyFloatNumber="true"
                  maxlength="8"
                  prepend="$" />
              </div>
              <div
                v-if="item.field_2"
                class="form-half">
                <v-input
                  v-model="item.value_2"
                  :disabled="disabled"
                  :keyFloatNumber="true"
                  maxlength="8"
                  append="%" />
              </div>
            </template>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralHomeExcess} from '@/api/refer'
import {getRenewHomeExcess} from '@/api/renewal'

export default {
  name: 'HomefireExcessForm',
  mixins: [MixinOptions],
  props: {
    // excess: {
    //   type: Array,
    //   default: () => ([])
    // },
    form: {
      type: Object,
      default: () => ({})
    },
    referId: {
      type: [String, Number],
      default: ''
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      excessForm: [],
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    // form: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(this.formDataLock !== this.oldFormDataLock) {
    //       this.oldFormDataLock = this.formDataLock
    //       Object.keys(this.formData).some(key => {
    //         if(key in val) {
    //           this.formData[key] = val[key]
    //         }
    //       })
    //     }
    //   }
    // }
    'form.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.network().getReferralHomeExcess()
        }
      }
    },
    // excess: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(val && this.formDataLock !== this.oldFormDataLock) {
    //       this.oldFormDataLock = this.formDataLock
    //       this.excessForm = JSON.parse(JSON.stringify(val))
    //     }
    //   }
    // }
  },
  methods: {
    submitForm() {
      // const params = JSON.parse(JSON.stringify(this.excessForm))
      const params = this.handlerExcessFormResult()
      this.$emit('getFormData', params)
      return params
    },
    initExcessForm() {
      // 處理回填 excess
      this.excessForm.some(excess => {
        excess.items.some(item => {
          // 不知道有多少個，暫時設定為 10  todo
          for(let i = 1; i <= 10; i++) {
            let field = `field_${i}`
            if(!item[field]) {
              continue
            }
            const key = item[field]
            if(key in this.form) {
              item[`value_${i}`] = this.form[key]
            }
          }
        })
      })
    },
    handlerExcessFormResult() {
      let params = {}
      this.excessForm.some(excess => {
        excess.items.some(item => {
          for(let i = 1; i <= 10; i++) {
            let field = `field_${i}`
            if(!item[field]) {
              continue
            }
            const key = item[field]
            params[key] = item[`value_${i}`]
          }
        })
      })
      return params
    },
    network() {
      return {
        getReferralHomeExcess: async () => {
          const { company_id, plan_id, id } = this.form
          let params = {
            company_id,
            plan_id,
          }
          if(this.referId && this.editType != 3) {
            params.refer_id = this.referId
          }
          else {
            params.order_id = this.editType == 3? this.renewOrderId : id
          }
          if(this.editType == 3){
            var {data} = await getRenewHomeExcess({
              ...params,
              hideLoading: true
            })
          }else{
            var { data } = await getReferralHomeExcess({
              ...params,
              hideLoading: true
            })
          }
          this.excessForm = data
          this.initExcessForm()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.excess-form {
    .flex-excess {
            display: flex;
            align-items: center;
            & > .el-checkbox {
                margin: 0 15px;
            }
            & > span {
                display: inline-block;
                padding: 0 15px;
            }
        }
        .form-excess-half {
            width: 500px;
        }
}
</style>
